module.exports = __webpack_public_path__ + "static/media/it-for-kids.c3ce1f0a.png";